// src/services/savedSearch.service.ts
import api from "./api";

export interface SavedSearchPayload {
  SearchName?: string;

  MakeID?: string | null;
  BrandID?: string | null;
  ModelID?: string | null;
  BodyTypeID?: string | null;
  FuelTypeID?: string | null;
  ColorID?: string | null;

  CountryID?: string | null;
  StateID?: string | null;
  CityID?: string | null;

  PriceMin?: number | string | null;
  PriceMax?: number | string | null;

  YearMin?: number | null;
  YearMax?: number | null;

  MileageMin?: number | string | null;
  MileageMax?: number | string | null;

  TransmissionType?: number | null;
  Condition?: string | null;
  DriveType?: string | null;
  PurchaseType?: number | null;
  IsFirstOwner?: boolean | null;

  FeatureIDs?: string[];

  NotifyEmail?: boolean;
  NotifyInApp?: boolean;
  IsActive?: boolean;
}

export interface SavedSearch extends SavedSearchPayload {
  id: string;
  CustomerID: string;
  CreatedOn: string;
  UpdatedOn: string;
}

// Create a saved search for the logged-in buyer
export const createSavedSearch = async (
  payload: SavedSearchPayload
) => {
  const response = await api.post(
    "/saved-searches",
    payload
  );

  return response.data;
};

// Get saved searches belonging to the logged-in buyer
export const getSavedSearches = async () => {
  const response = await api.get("/saved-searches");

  return response.data;
};

// Update a saved search
export const updateSavedSearch = async (
  id: string,
  payload: Partial<SavedSearchPayload>
) => {
  const response = await api.put(
    `/saved-searches/${id}`,
    payload
  );

  return response.data;
};

// Delete a saved search
export const deleteSavedSearch = async (id: string) => {
  const response = await api.delete(
    `/saved-searches/${id}`
  );

  return response.data;
};